import React from 'react';
import { Stream } from '../../Models/Stream';
import VideoCard from './VideoCard';

type Props = {
  streams: Stream[];
  savedStreams: Stream[];
  categoryId?: string;
};

const VideoGrid: React.FC<Props> = ({ streams, savedStreams, categoryId }) => {
  const IsStreamSaved = (Id: number): boolean => {
    return savedStreams.some((stream) => stream.id === Id);
  };

  return (
    <div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '16px',
    padding: '16px',
  }}
>
  {streams.map((stream) => (
    <VideoCard
      key={stream.id}
      stream={stream}
      saved={IsStreamSaved(stream.id)}
      goBackUrl={`/videos/${categoryId ?? ''}`}
    />
  ))}
</div>
  );
};

export default VideoGrid;
